import React from 'react'

const NotFound = () => {
  return (
    <div style={{ height: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <h1>Page Not Found</h1>
    </div>
  )
}

export default NotFound;